module.exports = __webpack_public_path__ + "static/media/mobile.0f470938.jpg";